import { Card, Row, Col, Spinner, Form, ButtonGroup, Button } from "react-bootstrap"
import { useState } from "react"
// import { useParams } from "react-router-dom"
import { useCallback, useEffect } from "react"
import { useSelector } from 'react-redux';
import AddNew from "./announcements/AddNew";
import AnnouncementCard from './announcements/AnnouncementCard';
import { toast } from "react-toastify";

export default function AnnouncementsCard({ homePageData, getHomePageData }) {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const [selectedGroup, setSelectedGroup] = useState("");
  const [announcementVisible, setAnnouncementVisible] = useState(false);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  const url = process.env.REACT_APP_URL;
  // const meetingId = useParams().meetingId;

  const [isLoading, setIsLoading] = useState(true);
  const [announcements, setAnnouncements] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { user: authUser } = useSelector(x => x.auth);

  useEffect(() => {
    if (homePageData) { setAnnouncementVisible(homePageData.announcement?.visible || false) }
  }, [homePageData]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const data = {
      "announcement.visible": announcementVisible,
    };
    try {
      const response = await fetch(`${url}/front`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser?.token}`
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        toast.success("Announcement visibility updated successfully.");
        getHomePageData();
      } else {
        const errorData = await response.json();
        toast.error(`Error updating announcement visibility: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error(`Error updating announcement visibility: ${error}`);
      toast.error(`Error updating announcement visibility: ${error.message || 'Unknown error'}`);
    }
  }, [announcementVisible, authUser, url, getHomePageData]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();

        // Check if the active element is inside this card
        const cardElement = document.getElementById('next-meeting-card'); // Add a unique ID to the card
        if (cardElement && cardElement.contains(document.activeElement)) {
          handleSubmit(e); // Trigger handleSubmit only for this card
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleSubmit]);

  const getAnnouncements = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${url}/announcements`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      setAnnouncements(data);
    } catch (e) {
      console.log(`Announcements component - Get Announcements error: ${e}`);
    }
    setIsLoading(false);
  }, [url]);

  useEffect(() => {
    getAnnouncements();
  }, [getAnnouncements]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleGroupChange = (group) => {
    setSelectedGroup(group);
  };

  // Filter announcements based on user access level
  const filteredAnnouncements = announcements.filter((announcement) => {
    if (!authUser) {
      // If no authenticated user, show only public announcements
      return announcement.to === "Public";
    }
    if (announcement.to === "Officer" && authUser.user.acl !== "Officer") {
      return false;
    }
    if (announcement.to === "Member" && !["Officer", "Member"].includes(authUser.user.acl)) {
      return false;
    }
    if (announcement.to === "Guest" && !["Officer", "Member", "Guest"].includes(authUser.user.acl)) {
      return false;
    }
    return true;
  });

  // Further filter announcements based on search term
  const searchedAnnouncements = filteredAnnouncements.filter((announcement) => {
    const searchTermLower = searchTerm.toLowerCase();
    return (
      announcement.title.toLowerCase().includes(searchTermLower) ||
      (announcement.shortDescription && announcement.shortDescription.toLowerCase().includes(searchTermLower)) ||
      (announcement.description && announcement.description.toLowerCase().includes(searchTermLower))
    );
  });

  // Group announcements based on the selected group
  const groupedAnnouncements = selectedGroup
    ? searchedAnnouncements.filter((announcement) => announcement.to === selectedGroup)
    : searchedAnnouncements;

  return (

    <Card className="mb-3 mt-3">
      <Card.Header onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
        <Row className="header mb-2">
          <Col xs={11} className="title">
            <h5 className="mb-0">Announcements</h5>
          </Col>
          <Col xs={1} className="text-end">
            <i className={`bi ${isCollapsed ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
          </Col>
        </Row>
      </Card.Header>
      {!isCollapsed && (
        isLoading ?
          <Spinner animation="border" variant="danger" />
          :
          <>
            <Card.Body className="to-left">
              <Row className="header mb-2">
                {(authUser && authUser.user.acl === 'Officer') &&
                  <Col xs={12} key={'newAnnouncement'}>
                    <AddNew getAnnouncements={getAnnouncements} />
                  </Col>
                }
              </Row>
              <Row className="mb-3">
                <Col xs={12}>
                  <Form.Control
                    type="text"
                    placeholder="Search Announcements"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    data-bs-theme={'dark'}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} lg={12}>
                  <ButtonGroup>
                    {authUser.user.acl === "Officer" && (
                      <Button
                        variant="outline-primary"
                        onClick={() => handleGroupChange("Officer")}
                        active={selectedGroup === "Officer"}
                      >
                        Officers
                      </Button>
                    )}
                    {["Officer", "Member"].includes(authUser.user.acl) && (
                      <Button
                        variant="outline-primary"
                        onClick={() => handleGroupChange("Member")}
                        active={selectedGroup === "Member"}
                      >
                        Members
                      </Button>
                    )}
                    {["Officer", "Member", "Guest"].includes(authUser.user.acl) && (
                      <Button
                        variant="outline-primary"
                        onClick={() => handleGroupChange("Guest")}
                        active={selectedGroup === "Guest"}
                      >
                        Guests
                      </Button>
                    )}
                    <Button
                      variant="outline-primary"
                      onClick={() => handleGroupChange("Public")}
                      active={selectedGroup === "Public"}
                    >
                      Public
                    </Button>
                    <Button
                      variant="outline-secondary"
                      onClick={() => handleGroupChange("")}
                      active={selectedGroup === ""}
                    >
                      All
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Row className="events-list">
                {groupedAnnouncements.length > 0 ? (
                  groupedAnnouncements.map((announcement) => (
                    <Col xs={12} key={announcement._id} className="mb-2">
                      <AnnouncementCard
                        announcement={announcement}
                        getAnnouncements={getAnnouncements}
                      />
                    </Col>
                  ))) :
                  <Col xs={12}>
                    <p className="text-center">No announcements found.</p>
                  </Col>
                }
              </Row>
            </Card.Body>
            <Card.Footer className="text-muted">
              <Row>
                <Col xs={8}>
                  <Form.Check
                    type="checkbox"
                    id="announcementVisible"
                    label="Announcement Visible"
                    checked={announcementVisible}
                    onChange={(e) => setAnnouncementVisible(e.target.checked)}
                    style={{ color: '#fff' }}
                  />
                </Col>
                <Col xs={4}>
                  <Button variant="primary" className="float-end" onClick={handleSubmit}>
                    <i className='bi bi-floppy'></i> Save
                  </Button>
                </Col>
              </Row>
            </Card.Footer>
          </>
      )}
    </Card>
  )
}